export function hasAliasOrTypeId(
  alias: string | undefined,
  typeId: number | null | undefined
) {
  return alias !== undefined || typeId !== undefined
}
